export const RESTRICAO_EMPRESAS = [
  ['edp', 'EDP'], ['endesa', 'Endesa'], ['iberdrola', 'Iberdrola'], ['galp', 'Galp'], ['repsol', 'Repsol'],
  ['goldenergy', 'Goldenergy'], ['yes', 'YES Energia'], ['meo', 'MEO'], ['nos', 'NOS'], ['vodafone', 'Vodafone'],
  ['digi', 'DIGI'], ['securitas', 'Securitas'], ['prosegur', 'Prosegur'], ['outra', 'Outra'],
];
export const RESTRICAO_TIPOS = { divida: 'Dívida', restricao: 'Restrição', incumprimento: 'Incumprimento' };
export const empresaLabel = (k) => (RESTRICAO_EMPRESAS.find(([v]) => v === k) || [k, k])[1];
export const restricoesResumo = (list) => (list || []).map((r) => `${RESTRICAO_TIPOS[r.tipo] || 'Dívida'}: ${empresaLabel(r.empresa)}`).join(' · ');
